export default __webpack_public_path__ + "static/media/hand-697264_640.45c60800.png";